import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';

interface apiParams {
    config?: AxiosRequestConfig;
}


function createAPI({config}: apiParams): AxiosInstance {

    let api = axios.create(config)

    // api.cachedItems = false;

    return api
}

function initCsrfHandler(apiInstance: AxiosInstance) {
    // automatically send CSRF token for all AJAX requests
    // Alter defaults after instance has been created
    apiInstance.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
    // можно на post или put

    // $.ajaxPrefilter(function (options, originalOptions, xhr) {
    //     if (!options.crossDomain && pub.getCsrfParam()) {
    //         xhr.setRequestHeader('X-CSRF-Token', pub.getCsrfToken());
    //     }
    // });
    // pub.refreshCsrfToken();

    // TODO не передавать csrf если это cross domain завпрос

}

function initRedirectHandler(apiInstance: AxiosInstance) {
    // handle AJAX redirection
    apiInstance.interceptors.response.use((response: AxiosResponse) => {
        const url = response.headers['x-redirect'];
        if (url) {
            window.location.assign(url);
        }
        return response;

    }, (error: any) => {
        /** Redirects попадают по умолчанию сюда */
        if (error.response && error.response.headers) {
            const url = error.response.headers['x-redirect'];
            if (url) {
                window.location.assign(url);
            }
        }
        return error;
    });

    // $(document).ajaxComplete(function (event, xhr) {
    //     var url = xhr && xhr.getResponseHeader('X-Redirect');
    //     if (url) {
    //         window.location.assign(url);
    //     }
    // });
}

/**
 * @return string|undefined the CSRF parameter name. Undefined is returned if CSRF validation is not enabled.
 */
// function getCsrfParam() {
//     return $('meta[name=csrf-param]').attr('content');
// }

/**
 * @return string|undefined the CSRF token. Undefined is returned if CSRF validation is not enabled.
 */
function getCsrfToken(): string {
    const meta: Element | null = document.querySelector('meta[name=csrf-token]');
    if (meta !== null) {
        const content: string | null = meta.getAttribute('content');
        return content !== null ? content : '';
    } else {
        return '';
    }
}


const api = createAPI({
    config: {
        // baseURL: `/api/v1/`,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            // 'X-CSRF-Token': getCsrfToken()
            // Authorization: 'Bearer {token}'
        },
        // withCredentials: true
    }
});

initCsrfHandler(api);
initRedirectHandler(api);


export default api;